<template>
  <DragDialog
    class="inner-pop-primary"
    title="新建类型"
    :width="400"
    :visible.sync="visible"
    :footerBtn="['submit', 'cancel']"
    :submit="submit"
    :cancel="closeDialog">
    <div class="anchor-group-form-box">
      <el-form
        :model="anchorTypeForm"
        :rules="rules"
        ref="groupForm"
        class="public-form-primary"
        label-width="80px">
        <el-form-item
          label="类型名称："
          prop="groupName">
          <el-input
            size="small"
            class="input-primary"
            :maxlength="30"
            v-model="anchorTypeForm.name"
            placeholder="请输入类型名称" />
        </el-form-item>
      </el-form>
    </div>
    <div class="tip-content-box">
      <span>
        注：您可以通过此弹窗快速创建新的类型。若需执行批量创建或其他更为复杂的管理操作，请前往
      </span>
      <span
        class="link-text"
        @click="enterDataDictionary">
        数字字典
      </span>
      <span>页面。</span>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import {
  getDataDictionaryTypeService,
  createDataDictionaryService
} from '@/service/dataDictionary'

export default {
  data() {
    return {
      typeId: '',
      anchorTypeForm: {
        name: ''
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入类型名称',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  props: {
    visible: Boolean
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initTypeId()
      }
    }
  },
  methods: {
    async initTypeId() {
      let catalogList = await this.queryDataDictionaryType()
      if (catalogList.length) {
        let find = catalogList.find(item => item.name.includes('批注'))
        this.typeId = find.id
      }
    },
    async submit() {
      let params = {
        typeId: this.typeId,
        name: this.anchorTypeForm.name
      }
      let response = await createDataDictionaryService(params)
      if (response.isSuccess) {
        let annotationPointTypeId = response.data
        this.$message.success('添加成功')
        this.$emit('refreshAnnotationTypeList', annotationPointTypeId)
        this.closeDialog()
      } else {
        this.$message.error(response.errMsg)
      }
    },
    closeDialog() {
      this.anchorTypeForm = { name: '' }
      this.$emit('closeAnchorTypeDialog')
    },
    enterDataDictionary() {
      let { projId, projName } = this.$route.params
      let { dataType, theme, isHeaderHidden } = this.$route.query
      const routerUrl = this.$router.resolve({
        path: `../../dataDictionary/${projId}/${projName}`,
        query: { dataType, theme, isHeaderHidden }
      })

      window.open(routerUrl.href, '_blank')
    },
    async queryDataDictionaryType() {
      let projId = this.$route.params.projId
      let response = await getDataDictionaryTypeService({ projId })
      if (response.isSuccess) {
        let data = response.data
        return data
      } else {
        this.$message.error(response.errMsg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.dialog-content) {
  .anchor-group-form-box {
    .public-form-primary {
      .el-form-item {
        margin-bottom: 0px;
        .el-form-item__label {
          padding: 0px;

          &::before {
            margin-right: 2px;
          }
        }
      }
    }
  }

  .tip-content-box {
    margin-top: 16px;
    padding: 0px 10px;
    font-size: 12px;
    color: var(--page-tips-text-color);
    font-weight: 400;
    line-height: 20px;

    .link-text {
      color: var(--base-bg-light-color50);
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
